import { render, staticRenderFns } from "./CarouselAdmin.vue?vue&type=template&id=7b46bb4f&scoped=true"
import script from "./CarouselAdmin.vue?vue&type=script&lang=js"
export * from "./CarouselAdmin.vue?vue&type=script&lang=js"
import style0 from "./CarouselAdmin.vue?vue&type=style&index=0&id=7b46bb4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b46bb4f",
  null
  
)

export default component.exports